"use strict";
var e, t;
function r() {
  return t || (t = 1, e = typeof Reflect < "u" && Reflect.getPrototypeOf || null), e;
}
export {
  r as __require
};
//# sourceMappingURL=index.es322.js.map
